import routes from '../app/routes';

export function useLoginPageRedirectRoute() {
  // In future there can possibly be some information about the previous page in query params
  return routes.login;
}
